"use client";

/**
 * Has this person asked for less movement?
 *
 * The CSS variant handles most cases and should be preferred — a transition
 * or an animation can simply be shortened or dropped in a `motion-reduce:`
 * rule. This exists for the ones CSS cannot reach: a looping video, which
 * keeps playing however it is styled, and anything driven from JavaScript.
 *
 * False before hydration, because the server cannot know. That means a video
 * gated on this renders paused on its poster for a frame either way, which is
 * the right way round: starting still and then playing is a beat late, while
 * starting in motion and then stopping is the thing the preference exists to
 * prevent.
 */

import { useCallback, useSyncExternalStore } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

export function usePrefersReducedMotion(): boolean {
  const subscribe = useCallback((onChange: () => void) => {
    const mql = window.matchMedia(QUERY);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(QUERY).matches,
    () => false,
  );
}
